module.exports = __webpack_public_path__ + "img/midwest-spring-1920x550.69d46158.jpg";